import { createRouter, createWebHistory } from "vue-router"
import Layout from "@/views/Layout.vue";

const Landing = ()=> import(/* webpackChunkName: "landing" */'@/views/Landing.vue')
const Mdestiny = ()=> import(/* webpackChunkName: "microsite-destiny" */'@/views/microsites/destiny/Destiny.vue')

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/landing",
        component: Landing
      },
      {
        path: "/micro-site/destiny",
        component: Mdestiny,
      },
    ]

  },
]

const router = createRouter({
    history : createWebHistory(),
    base:"/",
    routes
})

export default router;
